// removed by extract-text-webpack-plugin
module.exports = {"mainSliderContainer":"mainSliderContainer__WsqnD","bannerImgContainer":"bannerImgContainer__IqEFr","lightboxContainer":"lightboxContainer__1GU5V","videoFrame":"videoFrame__2GH-g","closeAction":"closeAction__2mmSf"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/banners/style.css
// module id = kqDD
// module chunks = 323